import React, { useState, useEffect } from "react";
import httpClient from "../../utils/httpClients";
import { Link } from "react-router-dom";
import Loader from "../../loader/loader";
function FAQs() {
  const [activePanel, setActivePanel] = useState("collapseOne");
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const togglePanel = (panelId) => {
    if (activePanel === panelId) {
      setActivePanel(null);
    } else {
      setActivePanel(panelId);
    }
  };

  const fetchFaqs = async () => {
    try {
      setLoading(true);
      const res = await httpClient.get(
        "/user/faq/all-faq?pageSize=10&pageNumber=1",
      );

      if (res.data.success) {
        setFaqs(res.data.data.getallFaq);
      }
    } catch (err) {
      setError("Failed to load FAQs. Please try again later.");
      console.error("API Error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFaqs();
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="content-inner pb-0 container-fluid" id="page_layout">
      <div className="row row--grid">
        {/* breadcrumb */}
        <div className="col-12">
          <ul className="breadcrumb">
            <li className="breadcrumb__item">
              <Link to="/">Home</Link>
            </li>
            <li className="breadcrumb__item breadcrumb__item--active">FAQ</li>
          </ul>
        </div>
        {/* end breadcrumb */}

        <div className="faq">
          <div className="col-md-12">
            {loading && (
              <div className="text-center">
                <Loader />
              </div>
            )}

            {error && (
              <div className="alert alert-danger" role="alert">
                {error}
              </div>
            )}

            {!loading && !error && faqs.length === 0 && (
              <div className="text-center">
                No FAQs available at the moment.
              </div>
            )}

            <div
              className="panel-group"
              id="accordion"
              role="tablist"
              aria-multiselectable="true"
            >
              {faqs.map((faq, index) => {
                const panelId = `collapse${index}`;
                const headingId = `heading${index}`;

                return (
                  <div className="panel panel-default" key={faq.id}>
                    <div className="panel-heading" role="tab" id={headingId}>
                      <h4 className="panel-title">
                        <a
                          data-toggle="collapse"
                          data-parent="#accordion"
                          href={`#${panelId}`}
                          aria-expanded={activePanel === panelId}
                          aria-controls={panelId}
                          className={
                            activePanel === panelId ? panelId : "collapsed"
                          }
                          onClick={(e) => {
                            e.preventDefault();
                            togglePanel(panelId);
                          }}
                        >
                          {faq.question}
                        </a>
                      </h4>
                    </div>
                    <div
                      id={panelId}
                      className={`panel-collapse collapse ${
                        activePanel === panelId ? "in show" : ""
                      }`}
                      role="tabpanel"
                      aria-labelledby={headingId}
                    >
                      <div className="panel-body">{faq.answer}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FAQs;
